var MIN_SUM = 5000;
var site = {};
var myMap;
var rur='&nbsp;Р';var noprice='<span class="noprice">уточните у менеджера</span>';
var cart = [];

if ($.cookie('cart')) {
	try {
		cart = eval($.cookie('cart'));
	}
	catch(err) {
		cart = [];
	}
	if (!cart) {
		cart = [];
	}
}
$(document).click(function(){
	$('.js-navbar-header-block').removeClass('active-navbar-header-block');
	$('.js-navbar-header-block button[aria-expanded="true"').parent().addClass('active-navbar-header-block ');
});

(function(window, $, undefined) {
    $.fn.touchwipe = function(settings) {
        var config = {
            min_move_x: 20,
            min_move_y: 20,
            wipeLeft: function() {},
            wipeRight: function() {},
            wipeUp: function() {},
            wipeDown: function() {},
            preventDefaultEvents: true
        };
        if (settings) $.extend(config, settings);
        this.each(function() {
            var startX;
            var startY;
            var isMoving = false;

            function cancelTouch() {
                this.removeEventListener('touchmove', onTouchMove);
                startX = null;
                isMoving = false;
            }

            function onTouchMove(e) {
                if (config.preventDefaultEvents) {
                    e.preventDefault();
                }
                if (isMoving) {
                    var x = e.touches[0].pageX;
                    var y = e.touches[0].pageY;
                    var dx = startX - x;
                    var dy = startY - y;
                    if (Math.abs(dx) >= config.min_move_x) {
                        cancelTouch();
                        if (dx > 0) {
                            config.wipeLeft();
                        } else {
                            config.wipeRight();
                        }
                    } else if (Math.abs(dy) >= config.min_move_y) {
                        cancelTouch();
                        if (dy > 0) {
                            config.wipeDown();
                        } else {
                            config.wipeUp();
                        }
                    }
                }
            }

            function onTouchStart(e) {
                if (e.touches.length == 1) {
                    startX = e.touches[0].pageX;
                    startY = e.touches[0].pageY;
                    isMoving = true;
                    this.addEventListener('touchmove', onTouchMove, false);
                }
            }
            if ('ontouchstart' in document.documentElement) {
                this.addEventListener('touchstart', onTouchStart, false);
            }
        });
        return this;
    };
    $.elastislide = function(options, element) {
        this.$el = $(element);
        this._init(options);
    };
    $.elastislide.defaults = {
        speed: 0,
        easing: '',
        imageW: 9010,
        margin: 0,
        border: 0,
        minItems: 100,
        current: 0,
        onClick: function() {
            return false;
        }
    };
    $.elastislide.prototype = {
        _init: function(options) {
            this.options = $.extend(true, {}, $.elastislide.defaults, options);
            this.$slider = this.$el.find('ul');
            this.$items = this.$slider.children('li');
            this.itemsCount = this.$items.length;
            this.$esCarousel = this.$slider.parent();
            this._validateOptions();
            this._configure();
            this._addControls();
            this._initEvents();
            this.$slider.show();
            this._slideToCurrent(false);
        },
        _validateOptions: function() {
            if (this.options.speed < 0) this.options.speed = 450;
            if (this.options.margin < 0) this.options.margin = 4;
            if (this.options.border < 0) this.options.border = 1;
            if (this.options.minItems < 1 || this.options.minItems > this.itemsCount) this.options.minItems = 1;
            if (this.options.current > this.itemsCount - 1) this.options.current = 0;
        },
        _configure: function() {
            this.current = this.options.current;
            this.visibleWidth = "100%";
            if (this.visibleWidth < this.options.minItems * (this.options.imageW + 2 * this.options.border) + (this.options.minItems - 1) * this.options.margin) {
                this._setDim((this.visibleWidth - (this.options.minItems - 1) * this.options.margin) / this.options.minItems);
                this._setCurrentValues();
                this.fitCount = this.options.minItems;
            } else {
                this._setDim();
                this._setCurrentValues();
            }
            this.$slider.css({
                width: this.sliderW
            });
        },
        _setDim: function(elW) {
            this.$items.css({
                marginRight: this.options.margin,
                width: (elW) ? elW : this.options.imageW + 2 * this.options.border
            }).children('a').css({
                borderWidth: this.options.border
            });
        },
        _setCurrentValues: function() {
            this.itemW = this.$items.outerWidth(true);
            this.sliderW = this.itemW * this.itemsCount;
            this.visibleWidth = "100%";
            this.fitCount = Math.floor(this.visibleWidth / this.itemW);
        },
        _addControls: function() {
            this.$navNext = $('<span class="es-nav-next">Next</span>');
            this.$navPrev = $('<span class="es-nav-prev">Previous</span>');
            $('<div class="es-nav"/>').append(this.$navPrev).append(this.$navNext).appendTo(this.$el);
            this._toggleControls();
        },
        _toggleControls: function(dir, status) {
            if (dir && status) {
                if (status === 1)(dir === 'right') ? this.$navNext.show() : this.$navPrev.show();
                else(dir === 'right') ? this.$navNext.hide() : this.$navPrev.hide();
            } else if (this.current === this.itemsCount - 1 || this.fitCount >= this.itemsCount) this.$navNext.hide();
        },
        _initEvents: function() {
            var instance = this;
            $(window).on('resize.elastislide', function(event) {
                instance._reload();
                clearTimeout(instance.resetTimeout);
                instance.resetTimeout = setTimeout(function() {
                    instance._slideToCurrent();
                }, 200);
            });
            this.$navNext.on('click.elastislide', function(event) {});
            this.$navPrev.on('click.elastislide', function(event) {});
            this.$slider.on('click.elastislide', 'li', function(event) {
                instance.options.onClick($(this));
                return false;
            });
            instance.$slider.touchwipe({
                wipeLeft: function() {},
                wipeRight: function() {}
            });
        },
        reload: function(callback) {
            this._reload();
            if (callback) callback.call();
        },
        _reload: function() {
            var instance = this;
            instance._setCurrentValues();
            if (instance.visibleWidth < instance.options.minItems * (instance.options.imageW + 2 * instance.options.border) + (instance.options.minItems - 1) * instance.options.margin) {
                instance._setDim((instance.visibleWidth - (instance.options.minItems - 1) * instance.options.margin) / instance.options.minItems);
                instance._setCurrentValues();
                instance.fitCount = instance.options.minItems;
            } else {
                instance._setDim();
                instance._setCurrentValues();
            }
            instance.$slider.css({
                width: instance.sliderW + 10
            });
        },
        _slide: function(dir, val, anim, callback) {
            var ml = parseFloat(this.$slider.css('margin-left'));
            if (val === undefined) {
                var amount = this.fitCount * this.itemW,
                    val;
                if (amount < 0) return false;
                if (dir === 'right' && this.sliderW - (Math.abs(ml) + amount) < this.visibleWidth) {
                    amount = this.sliderW - (Math.abs(ml) + this.visibleWidth) - this.options.margin;
                    this._toggleControls('right', -1);
                    this._toggleControls('left', 1);
                } else if (dir === 'left' && Math.abs(ml) - amount < 0) {
                    amount = Math.abs(ml);
                    this._toggleControls('left', -1);
                    this._toggleControls('right', 1);
                } else {
                    var fml;
                    (dir === 'right') ? fml = Math.abs(ml) + this.options.margin + Math.abs(amount): fml = Math.abs(ml) - this.options.margin - Math.abs(amount);
                    if (fml > 0) this._toggleControls('left', 1);
                    else
                        this._toggleControls('left', -1);
                    if (fml < this.sliderW - this.visibleWidth) this._toggleControls('right', 1);
                    else
                        this._toggleControls('right', -1);
                }(dir === 'right') ? val = '-=' + amount: val = '+=' + amount
            } else {
                var fml = Math.abs(val);
                if (Math.max(this.sliderW, this.visibleWidth) - fml < this.visibleWidth) {
                    val = -(Math.max(this.sliderW, this.visibleWidth) - this.visibleWidth);
                    if (val !== 0) val += this.options.margin;
                    this._toggleControls('right', -1);
                    fml = Math.abs(val);
                }
                if (fml > 0) this._toggleControls('left', 1);
                else
                    this._toggleControls('left', -1);
                if (Math.max(this.sliderW, this.visibleWidth) - this.visibleWidth > fml + this.options.margin) this._toggleControls('right', 1);
                else
                    this._toggleControls('right', -1);
            }
            $.fn.applyStyle = (anim === undefined) ? $.fn.animate : $.fn.css;
            var sliderCSS = {
                marginLeft: val
            };
            var instance = this;
            this.$slider.stop().applyStyle(sliderCSS, $.extend(true, [], {
                duration: this.options.speed,
                easing: this.options.easing,
                complete: function() {
                    if (callback) callback.call();
                }
            }));
        },
        _slideToCurrent: function(anim) {
            var amount = this.current * this.itemW;
            this._slide('', -amount, anim);
        },
        add: function($newelems, callback) {
            this.$items = this.$items.add($newelems);
            this.itemsCount = this.$items.length;
            this._setDim();
            this._setCurrentValues();
            this.$slider.css({
                width: this.sliderW
            });
            this._slideToCurrent();
            if (callback) callback.call($newelems);
        },
        setCurrent: function(idx, callback) {
            this.current = idx;
            var ml = Math.abs(parseFloat(this.$slider.css('margin-left'))),
                posR = ml + this.visibleWidth,
                fml = Math.abs(this.current * this.itemW);
            if (fml + this.itemW > posR || fml < ml) {
                this._slideToCurrent();
            }
            if (callback) callback.call();
        },
        destroy: function(callback) {
            this._destroy(callback);
        },
        _destroy: function(callback) {
            this.$el.off('.elastislide').removeData('elastislide');
            $(window).off('.elastislide');
            if (callback) callback.call();
        }
    };
    var logError = function(message) {
        if (this.console) {
            console.error(message);
        }
    };
    $.fn.elastislide = function(options) {
        if (typeof options === 'string') {
            var args = Array.prototype.slice.call(arguments, 1);
            this.each(function() {
                var instance = $.data(this, 'elastislide');
                if (!instance) {
                    logError("cannot call methods on elastislide prior to initialization; " + "attempted to call method '" + options + "'");
                    return;
                }
                if (!$.isFunction(instance[options]) || options.charAt(0) === "_") {
                    logError("no such method '" + options + "' for elastislide instance");
                    return;
                }
                instance[options].apply(instance, args);
            });
        } else {
            this.each(function() {
                var instance = $.data(this, 'elastislide');
                if (!instance) {
                    $.data(this, 'elastislide', new $.elastislide(options, this));
                }
            });
        }
        return this;
    };
})(window, jQuery);

$(function() {
    $.fn.imagesLoaded = function(callback) {
        var $images = this.find('img'),
            len = $images.length,
            _this = this,
            blank = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

        function triggerCallback() {
            callback.call(_this, $images);
        }

        function imgLoaded() {
            if (--len <= 0 && this.src !== blank) {
                setTimeout(triggerCallback);
                $images.off('load error', imgLoaded);
            }
        }
        if (!len) {
            triggerCallback();
        }
        $images.on('load error', imgLoaded).each(function() {
            if (this.complete || this.complete === undefined) {
                var src = this.src;
                this.src = blank;
                this.src = src;
            }
        });
        return this;
    };
});

function viewLimit(limit) {
	$.cookie('limit', limit, {"path": '/'});
	location.reload();
}

function fClick(el) {
	var id = $(el).attr('id');
	$('.brands-logos li').hide();
	$('.brands-logos li.'+id).show();
	$('.brands-filter li').removeClass('selected current');
	$(el).closest('li').addClass('selected current').append($('.brands-logos'));
	if (id && $('#'+id).length) {
		location.hash = '#filter-'+id;
	}
}

function showFilter()
{
	if ($('#filter').length && $('.filter-collapsed').is(":visible")) {
		initFilter();
		console.log('#f' + $('#filter-cat-selector').length);
		if($('#filter-cat-selector').length > 0)
		{
			$('#filter .filter-cat').hide();
			$('#filter #filter-cat-'+$('#filter-cat-selector').val()).show();
		}
		$('select[name=brand_id]').filter(':not(.select2-hidden-accessible)').select2();

	    $(".slider_min, .slider_max").change(function(){
            var $p = $(this).closest('.allwti');
	        var value1=$p.find('.slider_min').val();
	        var value2=$p.find('.slider_max').val();
	        if(parseInt(value1) > parseInt(value2)){
		        var tmp = value1;
		        value1 = value2;
		        value2 = tmp;

				$p.find('.slider_min').val(value1);
				$p.find('.slider_max').val(value2);
	        }
	    });

	}
}

function getAvaibilityTitleHTML(item) {
    var count = item.count ? '<div class="count">'+item.count+(item.reserved ? '&nbsp-'+item.reserved + ( item.reservedfuga ? '&nbsp;+'+item.reservedfuga : '') : '') +'&nbsp;шт</div>' : '';
    var tmp = '';
    if (item.pref == 'prod_') {
        tmp += count+ '<div class="name">Комплектация: '+item.name+'</div>';
        tmp = '<div class="l0">'+tmp+'</div>';
    }
    else if (item.pref == 'base_') {
        tmp = count + (item.name ? '<div class="bold"><div class="name">'+item.name+'</div>' : '') +
        (count ? '<div class="date '+(item.expired==1 ? 'expired' : '')+'">от&nbsp;'+item.date+'</div>' : '' ) + '</div>'+
        (item.info && item.info.match(/\w/) ? '<div class="dscr">'+item.info+(item.comment ? '<br>'+item.comment : '')+ '</div>' : '');
    }
    else if (item.pref == 'item_') {
        tmp += (item.art ? '<b>'+item.art+'</b>, ' : '')+' '+item.brand+' '+item.name;
    }
    else {
        tmp += '<div class="dotted">'+count+'<div class="bold name '+(item.enabled ? '' : 'red')+'">'+item.name+'</div></div>';
    }

    return tmp;
}

$(document).ready(function() {
        $.get('/cgi-bin/sessions.cgi');

	$('body').on('click',function(e){
		if($('.allwti--absolute') && (!e.target.closest('.in'))){
			$('.allwti--absolute').removeClass('in');
		}
	})
	$('.show-filters--js').on('click',function(){
		if($('.filters-body').find('.multi-collapse.collapse:not(.in)').length){
			$('.show-filters--js').html("свернуть");
		}else{
			$('.show-filters--js').html("все фильтры");
		}
	})
	
	$('.index-text__collapse__trigger').click(function () {
		if($(this).hasClass('collapsed')) $(this).text('Скрыть')
	})

    $('.avail-set').click(function () {
        var $this = $(this);
        if ($this.closest('.dropdown').find('.dropdown-menu').length) {
            $('.dropdown-menu').remove();
			return;
		}
        $this.button('loading');
        $.get('/avaibility/'+this.dataset.id+'/', function (data) {
            $this.button('reset');
            var $tree = $('<div class="dropdown-menu" style="padding:10px 10px 10px 20px"></div>');
            $this.closest('.dropdown').append($tree);
            $tree.tree({
                data: JSON.parse(data),
                dragAndDrop: false,
                autoOpen: true,
                selectable: false,
                autoEscape: false,
                useContextMenu: false,
                openedIcon: '-',
                closedIcon: '+',
                onCreateLi: function (item, $li) {
                    $li.find('.jqtree-title').html(getAvaibilityTitleHTML(item));
                }
            }).bind('tree.click',
            function(event) {
                $tree.tree('toggle', event.node);
            });

            var root = $tree.tree('getTree')
            for (var i=0; i<root.children.length; i++) {
                 $tree.tree('closeNode', root.children[i]);
            }

        });
    });
    $('.param-text').each(function () {
        var $p = $('#qs-'+this.dataset.id);
        var $q = $('<button type="button" class="btn btn-default btn-sm">'+
                    '?</button>');
        $q.click(function () {
            $(this).nextAll('.param-text').toggleClass('open');
        });
        $p.append($q);
        $p.append(this);

    });
	
	showFilter();
	MobileFilter();
    if($(".slide-one").length < 2 )
    {
         $(".slide-one").addClass("slide-one-0");  // There's only 1 slide so apply fix
	  console.log('set banner left 0 addclass');
    }

	var limit = parseInt($.cookie('limit')) || 30;
	$('.limits .active').removeClass('active');
	$('.limit'+limit).addClass('active');
	var order = $.cookie('order') || 'rating';
	$('.sort').each(function () {
		$(this).unbind('change');
		$(this).val(order).select2().change();
	}).change(function () {
		$.cookie('order', this.value, {"path": '/'});
		location.reload();
	});

	$('.show_all_cats').click(function(){
		$('.catalog-all-categ .item').show();
		$('.show_all_cats').remove();
	})

//	BrandsSelectorInit();


	if( location.href.indexOf('/brendy/')>=0 && location.href.indexOf('/brendy/strana-') < 0 ){
		$('.brands-filter li').click(function () {fClick(this)});
		if (!location.hash) {
			fClick($('.brands-filter li').get(0));
		}
		else {
			var id = location.hash.match(/filter-(.*)/) ? RegExp.$1 : '';
			if (id && $('#'+id).length) {
				fClick($('#'+id).get(0));
			}
		}
	}

	if( location.href.indexOf('/kontakty/')>=0 ){
		// <![CDATA[
		ymaps.ready(function() {
		$('#map-contacts').html();
			var myMap = new ymaps.Map("map-contacts", {
					center: [55.628988, 37.440496],
					zoom: 12
				});

				myMap.geoObjects.add(
					new ymaps.Placemark( [55.628988, 37.440496], {
						balloonContent: "ВСАНУЗЕЛ - продажа сантехники",
					},
					{preset: "twirl#blueDotIcon"}
					)
				);
		});
		// ]]></script>
	}

    $('.cmenu>li a, .cmenu-no>li a').click(function() {
		$(this).closest('li').toggleClass('active')
    });
    $('.cmenu .l2, .cmenu-no .l2').each(function() {
        $(this).prevAll('a').removeAttr('href').css('cursor', 'pointer')
    });

    $('.menu-kategory-title.mkt-yes').toggle(function() {
        $('.menu-kategory-title div').removeClass("mkt-up").addClass("mkt-down");
        $('.cmenu-no').animate({
            height: 'show'
        }, 500);
    }, function() {
        $('.menu-kategory-title div').removeClass("mkt-down").addClass("mkt-up");
        $('.cmenu-no').animate({
            height: 'hide'
        }, 500);
    });
    $('.menu-kategory-title.mkt-no').toggle(function() {
        $('.menu-kategory-title div.mkt-down').removeClass("mkt-down").addClass("mkt-up");
        $('.cmenu-no').animate({
            height: 'show'
        }, 500);
    }, function() {
        $('.menu-kategory-title div.mkt-up').removeClass("mkt-up").addClass("mkt-down");
        $('.cmenu-no').animate({
            height: 'hide'
        }, 500);
    });
    $(document).on('click', '.oa-list .pi-img, .oa-list .buy-btn, .panel-body .buy-btn', function() {
        location.href = $(this).closest('.panel-body').find('a').attr('href');
    });
    if ('contentcarousel' in $.fn) {
        $('#hit').contentcarousel();
        $('#sale').contentcarousel();
        $('#brand').contentcarousel();
        $('#recomend').contentcarousel();
    }
    if ('slidesjs' in $.fn) {
        $('#slides').slidesjs({
            play: {
                active: true,
                auto: true,
                interval: 6000,
                restartDelay: 2500,
                swap: true
            },
            effect: {
                slide: {
                    speed: 1200
                }
            }
        })
		$('.slides-left').each(function(){
			if($(this).children().length > 1){
				$(this).slidesjs({
					play: {
						active: true,
						auto: true,
						interval: 6000,
						restartDelay: 2500,
						swap: true
					},
					effect: {
						slide: {
							speed: 1200
						}
					}

				})
			}
		})
		/*
        $('.slides-left').slidesjs({

            play: {
                active: true,
                auto: true,
                interval: 6000,
                restartDelay: 2500,
                swap: true
            },
            effect: {
                slide: {
                    speed: 1200
                }
            }

        })*/
    };
    function get_srv_basket(id)  {
	$.get('/shopcart/',function(data)  {
	    var new_p = $(data);

	    $(".cart_product.item[data-id=7988] .total-price.cart_total-price", ).html(
		$(".cart_product.item[data-id=7988] .total-price.cart_total-price", new_p).html()
	    );

	    $(".cart_product.item[data-id=7988] .price.cart_price").html(
		$(".cart_product.item[data-id=7988] .price.cart_price", new_p).html()
	    );
	});
    }
    $('body').on("click", '.minus', function() {
        var $input = $(this).parent().parent().find('input');
        var count = parseInt($input.val()) - 1;
        count = count < 0 ? 0 : count;

		if($('.cart-wrap .product-cart') && count == 0){
			if(confirm("Удалить позицию?")){
				removeFromCartExtend( $(this).closest('.element_cat') );
			}else{
				count = 1;
			}
		}

		$input.val(count);
        $input.change();
        $input.keyup();
        callProductCart();
        callSummaryCart();
        if( document.location.pathname == "/shopcart/" )  {
            get_srv_basket( $(this).attr('data-id') );
        }
        return false;
    });
    $('body').on("click", '.plus', function() {
        var $input = $(this).parent().parent().find('input');
        $input.focus();
        $input.val(parseInt($input.val()) + 1);
        $input.change();
        $input.keyup();
        callProductCart();
        callSummaryCart();

        if( document.location.pathname == "/shopcart/" )  {
            get_srv_basket( $(this).attr('data-id') );
        }

        return false;
    });

    var nnkol = $('.kolnone').text();
    $('.btn-filtr div span').text(nnkol);
    $('.hidebrend2').hide();
    $('.category-all-2').mouseover(function() {
        $(this).children('.hidebrend2').show();
        $(this).mouseleave(function() {
            $(this).children('.hidebrend2').hide();
        });
    });

	function createCookie(name,value,days) {
		if (days) {
			var date = new Date();
			date.setTime(date.getTime()+(days*24*60*60*1000));
			var expires = "; expires="+date.toGMTString();
		}
		else var expires = "";
		document.cookie = name+"="+value+expires+"; path=/";
	}

	function readCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	}
	function eraseCookie(name) {
		createCookie(name,"",-1);
	}
	/*
	$('ul.brands-tabs').each(function(i) {
		var cookie = readCookie('tabCookie'+i);
		if (cookie) $(this).find('li').eq(cookie).addClass('current').siblings().removeClass('current').parents('div#brand-all').find('div.ptbox').hide().eq(cookie).show();
	});
	$('ul.brands-tabs').on('click', 'li:not(.current)', function() {
		$(this).addClass('current').siblings().removeClass('current').parents('div#brand-all').find('div.ptbox').eq($(this).index()).fadeIn(150).siblings('div.ptbox').hide();
		var ulIndex = $('ul.brands-tabs').index($(this).parents('ul.brands-tabs'));
		eraseCookie('tabCookie'+ulIndex);
		createCookie('tabCookie'+ulIndex, $(this).index(), 365);
	});
	*/
    $('ul.brands-tabs').each(function(i) {
        var cookie = readCookie('tabCookie' + i);
        if (cookie) $(this).find('li').eq(cookie).addClass('current').siblings().removeClass('current').parents('div#brand-all').find('div.ptbox').hide().eq(cookie).show();
    });
    $('ul.brands-tabs').on('click', 'li:not(.current)', function() {
        $(this).addClass('current').siblings().removeClass('current').parents('div#brand-all').find('div.ptbox').eq($(this).index()).fadeIn(150).siblings('div.ptbox').hide();
        var ulIndex = $('ul.brands-tabs').index($(this).parents('ul.brands-tabs'));
        eraseCookie('tabCookie' + ulIndex);
        createCookie('tabCookie' + ulIndex, $(this).index(), 365);
    });

    $('.menu-kategory-title.mkt-no').toggle(function() {
        $('.menu-kategory-title div.mkt-down').removeClass("mkt-down").addClass("mkt-up");
        $('.cmenu-no').animate({
            height: 'show'
        }, 500);
        $('body').css('min-height', '1595px');
    }, function() {
        $('.menu-kategory-title div.mkt-up').removeClass("mkt-up").addClass("mkt-down");
        $('.cmenu-no').animate({
            height: 'hide'
        }, 500);
        $('body').css('min-height', '0');
    });

    $('.vs-feedback form').submit(feedbackPost);
    $('.feedback-form').submit(feedbackPost);
	$('.lowerprice-form').submit(feedbackPost);
	$('.item1click-form').submit(feedbackPost);

	//$('.lowerprice-form').submit(lowerpricePost);
    $("a[rel='fancybox'], a.fancybox").fancybox();
    if ($('[data-bind="top-cart"]').length) {
        refresh_basket_info();
    };
    $('#order_block tr').each(function(i) {
        var number = -1 + i + 1;
        $(this).find('td.num:first').text(number);
    });
    $('.pt').click(function() {
        $('.pt').removeClass('current');
        $(this).addClass('current');
        var param = $(this).attr('data-param');
        $('.brands .h2title').remove();
        $brands = $('.brands .brand');
        $brands.sort(function(a, b) {
            if ($(a).attr('data-' + param) == $(b).attr('data-' + param)) {
                return $(a).text() < $(b).text() ? -1 : 1;
            }
            return $(a).attr('data-' + param) < $(b).attr('data-' + param) ? -1 : 1;
        });
        var current_param = '';
        for (var i = 0; i < $brands.length; i++) {
            if (current_param != $($brands[i]).attr('data-' + param)) {
                current_param = $($brands[i]).attr('data-' + param);
                $('.brands').append('<li class="h2title inht">' + current_param + '</li>');
            }
            $('.brands').append($brands[i]);
        }
    });
    $('.pt.current').trigger('click');

	scrollupInit();

	// табы на главной
	$('.group-products-filter-element').on('click', function(e)
	{
		$(this).addClass('active').siblings().removeClass('active');
		$($(this).data('href')).removeClass('hidden').siblings().addClass('hidden');
	});
	$('.list-inline li:first-child').trigger('click');

	// фанси на опции товара
	$(".ppr-all a.option-img").fancybox();

	$("#fancy-delivery, #fancy-payment").fancybox({
		'transitionIn'		: 'none',
		'transitionOut'		: 'none',
		'type' 				: 'inline',
		'height'			: '500',
		'width'				: '500'
	});

	$('input.icheckbox-orange').iCheck({
		checkboxClass: 'icheckbox_minimal-orange',
		radioClass: 'iradio_minimal',
		increaseArea: '20%' // optional
	});

	$('form.idfiltr').submit(filterSubmit);

	pages();

	if (location.hash && location.hash.match(/filter=1|page=\d+/) && !location.hash.match(/words=/)) {
    	loadFilter();
	}

	$('[data-toggle="tooltip"]').tooltip({container: 'body'});

	runcarousel();

	$('body').on('click', function(e){
		var c = $('#bs-navbar-collapse-catalog');
		if (c.has(e.target).length === 0){
			c.collapse('hide');
		}

		var c = $('#bs-navbar-collapse-search');
		if (c.has(e.target).length === 0){
			c.collapse('hide');
		}

		var c = $('#bs-navbar-collapse-menu');
		if (c.has(e.target).length === 0){
			c.collapse('hide');
		}
	});

	// скролл выпадающих меню
	checkDropdown();

	// поиск
	$('.search .input-group input[type=text]').focus(function()
	{
		var t = $('.search');
		t.attr('data-default', t.width());
		t.animate({ width: '70%' }, 'slow');
	})/*.blur(function()
	{
		var t = $('.search');
		var w = t.attr('data-default');
		t.animate({ width: w }, 'slow');
	});*/

	// уравнивание высоты картинок
	var max_menu_thumb = 0;
	/*$('.menu-thumb').each(function(){
		if($(this).height() > max_menu_thumb)
		{
			max_menu_thumb = $(this).height();
		}
	});

	$('.menu-thumb').height(max_menu_thumb);*/

	$("select[name=cart_user_type]").change(function(){
		if($(this).val() == 2){
			$('.ourname').show();
		}else{
			$('.ourname').hide();
		}
	});

	// search submit
	$('form[name="search"]').submit(function(e){
		e.preventDefault();
		//console.log($('form#search input').val() + ' ~~~ '); window.protocol + '//' + window.host +
		document.location.href  = '/search/#words=' + encodeURIComponent($(this).find('input[name=words]').val());

		//window.location.href = window.location.href;

		if(location.pathname == '/search/')
		{
			//location.reload();
			document.location.reload(true);
		}
	});

	// ajax search page
	if (location.hash && location.hash.match(/words=/) && location.pathname == '/search/') {
    	//loadFilter();
		$('body').addClass('loading2');
		console.log('ssssearch ' + location.hash.substr(1));
		$.get(location.pathname + '?ajax=1&' + location.hash.substr(1), function (data) {
			$('.catalog-prod-in.oa-list-one.row').html(data.items);
			$('.search_cats').html(data.search_header_cats);
			$('.paginator').html(data.pages ? data.pages.replace(/\?/g, '#') : '');
			$('.search-count').html(data.count);
			$('.search_brands_block').html(data.search_brands_block);

			var p = location.hash.substr(1).split('&');
			for(var i=0;i < p.length;i++) {
				var vals = p[i].split('=');
				if(vals[0] == 'words')
				{
					$('#search-words').html( decodeURIComponent(vals[1]) );
					break;
				}
			}

			$('body').removeClass('loading2');
		});
	}

	$('document, body').on('click', '.search-cat-link, .list-item-brand, .paginator a[data-page]', function(){
		console.log('ssssearch 22 ');
		$.get(location.pathname + '?ajax=1&' +  $(this).attr('href').split('#')[1], function (data) {
			$('.catalog-prod-in.oa-list-one.row').html(data.items);
			$('.search_cats').html(data.search_header_cats);
			$('.paginator').html(data.pages ? data.pages.replace(/\?/g, '#') : '');
			$('.search-count').html(data.count);
			$('.search_brands_block').html(data.search_brands_block);
		});
	});

	$(window).scroll(function () {
		var top = this.scrollTop || this.scrollY || $(window).scrollTop();
/*
		if (top > 180) {
			console.log('fadeIn');
			//$('#top-cart').html($('#cart').html());
		}
		else {
			console.log('fadeout');
		}
	*/
        if (top > 180 && !$('#link-top').hasClass('in')) {
            $('#link-top').addClass('in')
//			$('#link-top').fadeIn(500);
//            $('#top-cart').html($('#cart').html());
        }
        if (top < 180 && $('#link-top').hasClass('in') ) {
//			$('#link-top').fadeOut(500);
			$('#link-top').removeClass('in')
        }

	});


	// compare
	$('.btn-compare').click(function(e){
		e.preventDefault();

		var compare = $.cookie("compare") || '';
		compare_array = [];
		if(compare.length)
		{
			compare_array = compare.split(',');
		}

		if($(this).hasClass('active-btn'))
		{
			for (var i=0; i<compare_array.length; i++) {
				if(compare_array[i] == $(this).data('id'))
				{
					compare_array.splice(i, 1);
					break;
				}
			}
			$(this).removeClass('active-btn');
		}
		else
		{
			$(this).addClass('active-btn');
			compare_array.push($(this).data('id'));
		}

		$.cookie("compare", compare_array.join(','), {
			path: '/',
			expires: DateThroughMounth()
		});

		if(compare_array.length)
		{
			$('.compare-js').addClass('active-btn');
		}
		else
		{
			$('.compare-js').removeClass('active-btn');
		}

		$('.compare-js .badge').html(compare_array.length);
	});

	var compare = $.cookie("compare") || '';
	compare_array = [];
	if(compare.length)
	{
		compare_array = compare.split(',');
		$('.compare-js').addClass('active-btn');
	}

	for (var i=0; i<compare_array.length; i++) {
		$('[data-id=' + compare_array[i] + ']').addClass('active-btn');
	}

	$('.compare-js .badge').html(compare_array.length);

	// выравнивание строк в таблице стравнения
	if($('.comparelist').length)
	{
		var trheight = {};
		$('.comparetr').each(function(){
			var td = $(this).find('td');
			if(trheight[td.attr('data-rowid')] > 0)
			{
				if(trheight[td.attr('data-rowid')] < td.height())
				{
					trheight[td.attr('data-rowid')] = td.height();
				}
			}
			else
			{
				trheight[td.attr('data-rowid')] = td.height();
			}
		});

		$('.comparetr').each(function(){
			var td = $(this).find('td');
			td.height(trheight[td.attr('data-rowid')]);
		});

		// заголовки
		var p = $('.comparelist > div:nth-child(2) .item_attrs-js').position();

		if($('.attrs-header').length)
		{
			$('.attrs-header').css('margin-top', p.top);
		}
		/*
		$('#carousel-compare .carousel-inner div.item:first-child').addClass('active');
		$('#carousel-compare').carousel('pause');
		*/
	}

	$('.compare-all').click(function(){
		$(this).siblings().removeClass('disabled');
		$(this).addClass('disabled');
		$('.comparelist').removeClass('dif');
	});

	$('.compare-dif').click(function(){
		$(this).siblings().removeClass('disabled');
		$(this).addClass('disabled');
		$('.comparelist').addClass('dif');
	});

	// удаление из избранного
	$('.del-compare input').change(function(){
		console.log('del-compare input');
		if(	$('input[name=compare-del-checkbox]:checked').length > 0 )
		{
			$('.remove-compare').removeAttr('disabled');
		}
		else
		{
			$('.remove-compare').attr('disabled', 'disabled');
		}
	});

	$('.remove-compare').click(function(){
		var compare = $.cookie("compare") || '';
		compare_array = [];
		if(compare.length)
		{
			compare_array = compare.split(',');
		}

		$('input[name=compare-del-checkbox]:checked').each(function(){
			for (var i = 0; i < compare_array.length; i++) {
				if($(this).val() == compare_array[i])
				{
					compare_array.splice(i, 1);
				}
			}
		});

		$.cookie("compare", compare_array.join(','), {
			path: '/',
			expires: DateThroughMounth()
		});

		location.href = '/compare/?rnd='+Math.random();
	});
	$('.compare-js').click(function(e){
		e.preventDefault();
		location.href = '/compare/?rnd='+Math.random();
	});


    // favorites
	$('.favorites-js').click(function(e){
		e.preventDefault();
		location.href = '/favorites/?rnd='+Math.random();
	});
	$('.favorites-wrap .remove').click(function(){
        var favorites = $.cookie("favorites") || '';
        favorites_array = [];
        if(favorites.length)
        {
            favorites_array = favorites.split(',');
        }

		for (var i=0; i<favorites_array.length; i++) {
			if(favorites_array[i] == $(this).data('id'))
			{
				favorites_array.splice(i, 1);
				$.cookie("favorites", favorites_array.join(','), {
					path: '/',
					expires: DateThroughMounth()
				});

				break;
			}
		}
		location.href = '/favorites/?rnd='+Math.random();
	});

    $('.btn-favorites').click(function(e){
		e.stopPropagation();

		//console.log('izbrannoe');
        var favorites = $.cookie("favorites") || '';
        favorites_array = [];
        if(favorites.length)
        {
            favorites_array = favorites.split(',');
        }

        if($(this).hasClass('active-btn'))
        {
            for (var i=0; i<favorites_array.length; i++) {
                if(favorites_array[i] == $(this).data('id'))
                {
                    favorites_array.splice(i, 1);
                    break;
                }
            }
            $(this).removeClass('active-btn');
        }
        else
        {
            $(this).addClass('active-btn');
            favorites_array.push($(this).data('id'));
        }

        $.cookie("favorites", favorites_array.join(','), {
            path: '/',
            expires: DateThroughMounth()
        });

        if(favorites_array.length)
        {
            $('.favorites-js').addClass('active-btn');
        }
        else
        {
            $('.favorites-js').removeClass('active-btn');
        }

        $('.favorites-js span.badge, .favorites-jsxs span.badge small').html(favorites_array.length);

    });

    var favorites = $.cookie("favorites") || '';
    favorites_array = [];
    if(favorites.length)
    {
        favorites_array = favorites.split(',');
        $('.favorites-js').addClass('active-btn');
    }

    for (var i=0; i<favorites_array.length; i++) {
        $('.favorites-button[data-id=' + favorites_array[i] + ']').addClass('active-btn');
        $('.c_content div[data-id=' + favorites_array[i] + ']').html('Добавлено в избранное');

    }

    $('.favorites-js span.badge, .favorites-jsxs span.badge small').html(favorites_array.length);

    if ($('.container').first().innerWidth() > 750) {
        //$('.check-block').affix({});
    } else {
        $('.check-block').removeAttr('data-spy');
    }

	var timerid;
	// подсказки
	$(document).on("keyup", 'input[name="words"]', function(){
		words = $(this);

		clearTimeout(timerid);
		timerid = setTimeout(function() {

			console.log(words.val());
			if(words.val().length > 2)
			{
				// loading
				if($('.suggestion-block').length)
				{
				}
				else
				{
					$('input[name="words"]').after('<div class="suggestion-block loading"></div>');
				}

				$.get('/search/?suggestion=1&words=' + words.val(), function (data) {
					if (data.items) {
						if($('.suggestion-block').length)
						{
						}
						else
						{
							$('input[name="words"]').after('<div class="suggestion-block"></div>');
						}
						$('.suggestion-block').html(data.items)
					}
					else {
						// nothing - hide
					}

					$('.suggestion-block').removeClass('loading');

				})
			}
		}, 800);
	});
/*
	$('input[name="words"]').focus(function(){
		$('.suggestion-block').show();
	});
*/
	$(document).click(function(event) {

		if ($(event.target).closest('input[name="words"]').length) {console.log('click a 1'); $('.suggestion-block').show(); return;}
		if ($(event.target).closest(".btn.btn-search").length) {console.log('click a 2'); return;}
		if ($(event.target).closest(".suggestion-block a").length) {console.log('click a 3'); return  };
		if ($(event.target).closest(".suggestion-block").length) {console.log('click a 4'); return  };
		$('.suggestion-block').hide();

		// search input stretch
		var t = $('.search');
		var w = t.attr('data-default');
		t.animate({ width: w }, 'slow');

		event.stopPropagation();
	});

	$('.all-brands').click(function(){
		$('#filter-brands li').removeClass('hidden');
	});

	callSummaryCart();

// send gtag product preview
	$('a.gtag_product_link').click(function(e){
		var $item = $(this).closest('.item');

		gtag("event", "select_content", {
		  "content_type": "product",
		  "items": [{
			"id": $item.data('gtag_id'),
			"name": $item.data('gtag_name'),
			"price": $item.data('gtag_price'),
			"currency": "RUB",
			"brand": $item.data('gtag_brand'),
			"category": $item.data('gtag_category')
		  }]
		});
	});

	var gtag_items = [];
	$('.js-gtag-item').each(function(){
		$item = $(this);
		gtag_items.push({
			"id": $item.data('gtag_id'),
			"name": $item.data('gtag_name'),
			"price": $item.data('gtag_price'),
			"currency": "RUB",
			"brand": $item.data('gtag_brand'),
			"category": $item.data('gtag_category')
		});
	});

	if(gtag_items.length > 0) {
		gtag("event", "view_item_list", {
			"items": gtag_items
		});
	}

    runEcommerce();

    $("input[name=cart_name]").suggestions({
        token: "3ee057e1d57de9f677e2c4405d51e8f22df6ba8f",
        type: "NAME",
        count: 5,
		scrollOnFocus: false,
    });
    $("input[name=cart_email]").suggestions({
        token: "3ee057e1d57de9f677e2c4405d51e8f22df6ba8f",
        type: "EMAIL",
        count: 5,
		scrollOnFocus: false,
    });
	$("textarea[name=cart_address]").suggestions({
        token: "3ee057e1d57de9f677e2c4405d51e8f22df6ba8f",
        type: "ADDRESS",
        count: 5,
		scrollOnFocus: false,
    });
	$("input[name=cart_urname]").suggestions({
        token: "3ee057e1d57de9f677e2c4405d51e8f22df6ba8f",
        type: "PARTY",
        count: 5,
		scrollOnFocus: false,
        onSelect: showSuggestion
    });

    $("#lftnvbr li a").click(function(){
        $(this).parents("ul").children("li").removeClass("active");$(this).parents("li").addClass("active");
    });
    
    $('.pba-price-1, .pba-price-2, .buy-price .js-formatted-price, .buy-price .oldprice, .option .col-sm-3, .cart-row .cart_price, .cart-row .cart_total-price span, #summary, .cart_product .cart_total-price').each(function(){
        $(this).html( formatPrices( $(this).html() ) );
    });
    
    initGoodsSwiper('#similar-list');
});

function post_review() {
	$('#new_review input[type="submit"]').attr('disabled', true);
	var id = $('#new_review input[name="prod_id"]').val();
	var rating = $('#new_review select[name="rating"]').val();
	var name = $('#new_review input[name="name"]').val();
	if (!id || !name || !rating) {
		alert("Не корректно заполнена форма");
		$('#new_review input[type="submit"]').attr('disabled', false);
		return;
	}
	$.post('/new_review/', $('#new_review form').serialize(), function (data) {
		$('#new_review input[type="submit"]').attr('disabled', false);
		if (data && data.match(/ok/i)) {
			$('#new_review').modal('hide');
			alert("Спасибо за Ваш отзыв! Мы разместим его после проверки");
		}
		else {
			$('#new_review input[type="submit"]').attr('disabled', false);
			alert("Произошла непредвиденная ошибка, пожалуйста повторите попытку позже");
		}
	}).fail(function() {
		$('#new_review input[type="submit"]').attr('disabled', false);
		alert("Произошла непредвиденная ошибка, пожалуйста повторите попытку позже");
	});
}

function checkDropdown()
{
	$('#bs-navbar-collapse-catalog, #bs-navbar-collapse-menu').on('show.bs.collapse', function () {
		if($(this).height() > window.innerHeight - $('.header-xs .navbar-header').height())
		{
			$(this).css('max-height', window.innerHeight - $('.header-xs .navbar-header').height() + 'px');
		}
	});
}


function runcarousel(){
	if($(window).width() < 767)
	{
		$('#carousel-cats').html('<div class="carousel-inner" role="listbox">' + $('#carousel-cats').html() + '</div><a class="left carousel-control" href="#carousel-cats" role="button" data-slide="prev"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span><span class="sr-only">Previous</span></a><a class="right carousel-control" href="#carousel-cats" role="button" data-slide="next"><span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span><span class="sr-only">Next</span></a>');
		$('#carousel-cats div.item:first-child').addClass('active');
		$('#carousel-cats').carousel('pause');

// оборачиваю
		$('#sale').html('<div class="carousel-inner" role="listbox">' + $('#sale').html() + '</div><a class="left carousel-control" href="#sale" role="button" data-slide="prev"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span><span class="sr-only">Previous</span></a><a class="right carousel-control" href="#sale" role="button" data-slide="next"><span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span><span class="sr-only">Next</span></a>');
		$('#sale div.item:first-child').addClass('active');
		$('#sale').carousel('pause');
	}
}

function scrollupInit(){
	jQuery('#scrollup img').animate({opacity: 0.5},100);

	jQuery('#scrollup img').mouseover( function(){
		jQuery( this ).animate({opacity: 1},100);
	}).mouseout( function(){
		jQuery( this ).animate({opacity: 0.5},100);
	}).click( function(){
		window.scroll(0 ,0);
		return false;
	});

	jQuery(window).scroll(function(){
		var full_height = $(document).height();
		var window_height = $(window).height();
		var footer_height = $('footer').height();
		if ( jQuery(document).scrollTop() > 500 && jQuery(document).scrollTop() < (full_height - footer_height * 4)) {

			jQuery('#scrollup').fadeIn('fast');
		} else {

				jQuery('#scrollup').fadeOut('fast');
		}
	});
}

function changeAmountAndPrice(id, inputElem) {
    var e = jQuery(inputElem).next('input'),
        old = e.val();
    e.val(inputElem.value);
    if (jQuery('#item-' + id + ' input:checkbox').attr('checked') == 'checked') {
        site.basket.modifyPrice(id, inputElem.value, old);
    } else {
        site.basket.modify(id, inputElem.value, old);
    }
}

function set_basket_info(data) {
	data = data.replace(/\n/g, '');
	data = data.replace(/\r/g, '');

	var data1 = data.match(/(<button.*?button>)/)[0];
	var data2 = data.match(/(<div class="modal fade".*?<\/div>)$/m);
	var data3 = data1.replace(/<span class="cart-sum">.*?<\/span>/g, '');
	if(data2)
	{
		data2k = data2[0];
	}
	$('[data-bind="top-cart"]').html(data1).removeClass('loading');
	$('#link-top [data-bind="top-cart"]').html(data3);
	if( $('.modal.fade#cart').length > 0 ) {
		var modal_content = data2[0].match(/(<section class="modal\-content">.*<\/section>)/img);
		$('.modal.fade#cart .modal-content').replaceWith( modal_content );
	}
	else {
		$('body').append(data2k);
	}
    $('#success .modal-body').html('<div><button type="button" class="btn btn-default" data-dismiss="modal">Продолжить покупки</button><a role="button" class="btn btn-primary" href="/shopcart/?rnd='+Math.random()+'">Оформить заказ</a></div>').removeClass('loading');
}

function refresh_basket_info(force) {
	$.cookie("cart", JSON.stringify(cart), {
		path: '/',
		expires: DateThroughMounth()
	});
    if (force && location.pathname == '/shopcart/') {
		location.href = '/shopcart/?rnd=' + Math.random();
    }

    if (cart && cart.length  || force) {
        $.get('/cartajax/', function(data) {
			if(cart.length > 0 ){
				set_basket_info(data);
			}else{
				$('#cart').modal('hide')
				$('[data-bind="top-cart"] .badge').text('0');
				$('[data-bind="top-cart"] .cart-sum').html('0 <span class="rur">Р</span>');
				$('[data-bind="top-cart"]').on('hidden.bs.modal', function(){
					$(this).remove();
				});
				$('[data-bind="top-cart"] .right-cart').on('click',function(){
					location.href = '/shopcart/'
				})
			}
			$('.header-xs .badge').html(($('[data-bind="top-cart"] .badge').html()));

            $('#cart .cart-small_price, .cart .cart-sum').each(function(){
                $(this).html( formatPrices( $(this).html() ) );
            });
            
             
        });
        $('[data-bind="top-cart"]').addClass('loading');
    }
}

function add2cart() {
    var $selector = 0;
    var items = [];

    var src_sel = $(window).width() > 767 ? $('.hidden-xs .buy-hidden') : $('.visible-xs .buy-hidden');
    var parent_id = 0;
    var price_per_item = 0;
    if ($('.set').length) {
	$selector = $('.set .amount');
	var old_price = getPrice( $('.oldprice').html() );
	if ( old_price ) {
		parent_id = ( $(src_sel).attr('name') ).match(/(\d+)/)[1];
		price_per_item = Math.round( $("[data-js-id="+parent_id+"]").attr('data-js-price') / $selector.length );
	}
    }
    else {
        $selector = src_sel;
    }
	$selector.each(function () {
	    var id = (this.name+'').match(/(\d+)/)[1];
	    if (parseInt(id) && parseInt(this.value) > 0) {
	        items.push({
			"price_per_item": price_per_item,
			"parent_id": parent_id,
			"id": id,
			"c": this.value
		});
			// отказываюсь от data, тк возникла потребность в изменении этих данных
			gtag("event", "add_to_cart", {
				"currency": "RUB",
				"value": this.value,
				  "items": [{
					"id": id,
					"name": $(this).attr('data-js-name'),
					"price": price_per_item || $(this).attr('data-js-price'),
					"currency": "RUB",
					"brand": $(this).attr('data-js-brand'),
					"category": $(this).attr('data-js-category'),
				  }]
			});
	    }
	})

	if ($('.dop-options input').length && items[0]) {
		items[0].o = [];
		$('.dop-options input').each(function () {
			var id = this.value;
			if (parseInt(id) && this.checked) {
				items[0].o.push({"id": id, "c": 1});
			};
		})
	}

	for (var j=0; j<items.length; j++) {
		for (i=0; i<cart.length; i++) {
			if (cart[i].id == items[j].id) {
				break;
			}
		}

		if (i>=cart.length) {
			cart.push(items[j]);
		}
		else {
			cart[i] = items[j];
		}
	}

    $('[data-bind="top-cart"]').addClass('loading');
    if (!$('#success').length) {
        $('body').append('<div id="success" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="exampleModalLabel">Товар добавлен в корзину</h4></div><div class="modal-body"></div></div></div></div>');
    }
    $('#success .modal-body').html('Пожалуйста подождите, товар добавляется в корзину ...').addClass('loading');

	$('#success').modal();
	/*
	$.fancybox('#success', {
        width: 500,
        height: 180,
        autoSize: false,
        padding: 0
    });
	*/
    if (window.yaCounter32942089) {
        yaCounter32942089.reachGoal('Basket');
     }
    // yaCounter32942089.reachGoal('Basket');

	refresh_basket_info();
}

function removeFromCartExtend(el) {

	var item_id = el.attr('data-id');
	var opt_id = el.attr('data-opt-id');

	for (i=0; i<cart.length; i++) {
		if (cart[i].id == item_id ) {
			break;
		}
	}

	if(i>=cart.length){
		//cart.push(items[j]);
	}else{
		if(opt_id){
			for (j=0; j<cart[i].o.length; j++) {
				//console.log(cart[i].o[j].id);
				if ( cart[i].o[j].id == opt_id ) {
					break;
				}
			}

			if (j>=cart[i].o.length) {
				//cart.push(items[j]);
			}else{
				cart[i].o.splice(j,1);
			}
		}else{
            cart.splice(i, 1);
		}
	}
    refresh_basket_info(true);
}

function removeFromCart(id) {
    for (var i=0;i<cart.length;i++) {
        if (cart[i].id == id) {
            cart.splice(i, 1);
            break;
        }
    }

		refresh_basket_info(true);

}

function removeOptFromCart(id, opt_id) {
    for (var i=0;i<cart.length;i++) {
        if (cart[i].id == id) {
            if (cart[i].o) {
                for (var j=0;j<cart[i].o.length;j++) {
                    if (cart[i].o[j].id == opt_id) {
                        cart[i].o.splice(j, 1);
                        break;
                    }
                }
            }
            break;
        }
    }
    refresh_basket_info(true);
}

function initMap() {
    var myMap;
    $('.b1-two a, #minimap').click(function() {
        if (myMap) {
            return;
        }
         $('#mapm a.print').remove();
//          $('#mapm a.print').attr('href', "/map.html");
        myMap = new ymaps.Map("mainMap", {
            center: [55.626421, 37.441314],
            zoom: 12
        });
        myMap.geoObjects.add(new ymaps.Placemark([55.626421, 37.441314], {
            balloonContent: "РУСПЛИТКА - продажа и доставка керамической плитки и сантехники",
        }, {
            preset: "twirl#blueDotIcon"
        }));
    });
}

function callSummaryCart() {



    if (!$('.cart-wrap .product-cart').length) {
		return;
    };


	var total_sum = 0;

	$('.element_cat').each(function(){
		var line = $(this);
		var price = getPrice(line.find('.price span').html() );
		var amount = parseInt(line.find('.buy-number input').val()) || parseInt(line.find('.buy-price').attr('data-amount')) || 1;

		//console.log('price');
		//console.log(price);
		//console.log('amount');
		var item_id = line.attr('data-id');
		var opt_id = line.attr('data-opt-id');

		//console.log(amount);
		//console.log(line.find('.buy-number input'));
		for (i=0; i<cart.length; i++) {
			if (cart[i].id == item_id ) {
				break;
			}
		}

		if (i>=cart.length) {
			//cart.push(items[j]);
		}
		else {
			if(opt_id){
				for (j=0; j<cart[i].o.length; j++) {
					//console.log(cart[i].o[j].id);
					if ( cart[i].o[j].id == opt_id ) {
						break;
					}
				}

				if (j>=cart[i].o.length) {
					//cart.push(items[j]);
				}else{
					cart[i].o[j].c = amount;
				}
			}else{
				cart[i].c = amount;
			}
		}

		line.find('.buy-hidden').val(amount);
		var count = 1;
		if ($('.set').length) {
			price = 0;
			count = 0;
		}
		var sum = price + 0;
		line.find('.dop-options input, .set input').each(function() {
			if ((this.type == 'checkbox' && this.checked) || (this.type == 'text' && parseInt(this.value) > 0)) {
				$("input:checkbox").on('click', function() {
					var $box = $(this);
					if ($box.is(":checked")) {
						var group = "input:checkbox[name='" + $box.attr("name") + "']";
						$(group).prop("checked", false);
						$box.prop("checked", true);
					}else{
						$box.prop("checked", false);
					}
				});
				count++;

				//var tmp = getPrice(this.getAttribute('data-price')) * parseInt(this.value);
				var tmp = getPrice(this.getAttribute('data-price'));
				if (tmp > 0) {
					sum += tmp + 0;
				}
			}
		})
		sum *= amount;
		count *= amount;
		if (sum > 0) {
			line.find('.total-price').html(sum + rur);
		} else {
			line.find('.total-price').html(noprice);
		}
		line.find('.buy-txt span').html(count);

		total_sum += sum;
	});

	refresh_basket_info();

	if(total_sum < MIN_SUM)
	{
		$('.minsum').show();
		$('form[name=purchase] input[type=submit]').attr('disabled', true);
	}
	else
	{
		$('.minsum').hide();
		$('form[name=purchase] input[type=submit]').removeAttr('disabled');
	}

	//console.log(total_sum);

	$('#summary').html(total_sum + rur);
    
    $('#summary, .cart_product .cart_total-price span').each(function(){
        $(this).html( formatPrices( $(this).html() ) );
    });    
/*
    if (!$('.buy-totop').length) {
        $('body').append('<div class="buy-totop" style="right:' + ($('body').width() - $('.page-all').position().left - $('.page-all').outerWidth()) + 'px"></div>');
        $('.buy-totop').click(function() {
            $('html,body').animate({
                scrollTop: 1
            }, 500);
        }).hover(function() {
            clearTimeout($('.buy-totop').attr('data-timer'));
        }, function() {
            $(this).attr('data-timer', setTimeout(function() {
                $('.buy-totop').fadeOut();
            }, 3000));
        });
    }
    if (this && this.tagName) {
        var $b = $('.buy-totop');
        if ($b.attr('data-timer')) {
            clearTimeout($b.attr('data-timer'));
        }
        $b.css('top', Math.round($(this).position().top) + 'px').fadeIn().attr('data-timer', setTimeout(function() {
            $('.buy-totop').fadeOut();
        }, 3000)).html('Итого: ' + sum + rur)
    };
*/
}

function callProductCart() {

	if (!$('.element_cat').length)  return;


	var price = getPrice($('.buy-price').attr('data-js-price-one'));
	var amount = parseInt($('.buy-number input').val()) || parseInt($('.buy-price').attr('data-amount')) || 1;
	$('.buy-hidden').val(amount);
	var count = 1;
	var sel = '.dop-options input';
	var old_price = getPrice( $('.oldprice').html() );
	if ( $('.set').length && !old_price ) {
		price = 0;
		count = 0;
		sel += ", .set input";
	}
	var sum = price + 0;
	sum *= amount;
	count *= amount;

	$(sel).each(function() {
        if ((this.type == 'checkbox' && this.checked) ||
		(this.type == 'text' && parseInt(this.value) > 0)) {

            $("input:checkbox").on('click', function() {
                var $box = $(this);
                if ($box.is(":checked")) {
                    var group = "input:checkbox[name='" + $box.attr("name") + "']";
                    $(group).prop("checked", false);
                    $box.prop("checked", true);
                } else {
                    $box.prop("checked", false);
                }
            });
            count++;

            var tmp = (this.type=='text')
                        ? getPrice(this.getAttribute('data-price')) * parseInt(this.value)
                        : getPrice(this.getAttribute('data-price'));


            if (tmp > 0) {
                sum += tmp + 0;
            }
        }
	})
	if ( $('.set').length && old_price ) {
		if(price != sum)  $(".oldprice").hide();
		else  $(".oldprice").show();
		$('.buy-price [itemprop=price]').html(sum);
	}
	else  {
		if (sum > 0) {
			$('.buy-price').html(sum + rur);
		} else {
			$('.buy-price').html(noprice);
		}
	}

    $('.buy-txt span').html(count);
    if (!$('.buy-totop').length) {
        $('body').append('<div class="buy-totop" style="right:' + ($('body').width() -
                        $('.grey-line + .container').position().left -
                        $('.grey-line + .container').outerWidth()) + 'px"></div>');
        $('.buy-totop').click(function() {
            $('html,body').animate({
                scrollTop: 1
            }, 500);
        }).hover(function() {
            clearTimeout($('.buy-totop').attr('data-timer'));
        }, function() {
            $(this).attr('data-timer', setTimeout(function() {
                $('.buy-totop').fadeOut();
            }, 3000));
        });
    }
    if (this && this.tagName) {
        var $b = $('.buy-totop');
        if ($b.attr('data-timer')) {
            clearTimeout($b.attr('data-timer'));
        }
        $b.css('top', Math.round($(this).position().top) + 'px').fadeIn().attr('data-timer', setTimeout(function() {
            $('.buy-totop').fadeOut();
        }, 3000)).html('Итого: ' + sum + rur)
    };
}

$(document).ready(function() {
    $('.dop-options input, .set input').change(callProductCart);
	$('.dop-options input, .set input').on('ifChanged', function(event){
		callProductCart();
	});
    if ($('.price-block .buy-price .noprice').length) {
        $('.price-block .buy-txt').hide();
        $('.price-block .buy-all').hide();
    }
    $('.set input').change(function() {
        if (parseInt(this.value) > 0) {
            $(this).closest('tr').addClass('active');
        } else {
            $(this).closest('tr').removeClass('active');
        }
    });
    if ($('.set').length) {
        callProductCart();
    }
/*
    $('body').click(function() {
        $('.cart-none').hide();
    });
    $('.cart-none').click(function(event) {
        event.stopPropagation();
    });

    $('.cart-link').click(function(event) {
        $('.cart-none').toggle();
        event.stopPropagation();
    });
*/
    $('.prod-option input').change(function() {
        // redirect to product
        //location.href = $(this).next().find('a').attr('href');

		var $id = $(this).val();
		var $selected_option = $(this);
		$(this).closest('table').find('.active').removeClass('active');
		$(this).closest('table').find('.btn-primary').removeClass('btn-primary').addClass('btn-bordered').html('Выбрать');

        var $li = $(this).closest('tr');
        $li.find('td').addClass('active');
        $li.find('.op-buy .btn').removeClass('btn-bordered').addClass('btn-primary').html('Выбрано');

		// заменяю в чеке id на новый id
		$('.amountone').attr('id', 'amount_' + $id);

		$('input.buy-hidden').each(function(){
			$(this).attr('name', 'e[' + $id + ']');
		});

		// кнопка покупки
		$('button.send-btn').each(function(){
			$(this).attr('data-js-id', $id);
			$(this).attr('data-js-name', $selected_option.data('name'));
			$(this).attr('data-js-price', $selected_option.data('price1'));
		});

		// тумба и ссылка
		$('.check-thumb').css('background-image', 'url(' + $(this).data('thumb') + ')');
		$('.check-name').html('<a href="' + $(this).data('url') + '">' + $(this).data('name') + '</a>');

		// цены
		$('.buy-price').each(function(){
			$(this).attr('data-js-price-one', $selected_option.data('price1'));
			$(this).find('[itemprop="price"]').html( $selected_option.data('price1') );
		});

		$('.buy-podtxt span').html($id);
    });
    $('.op-buy').click(function() {
        if ($(this).hasClass('active')) {
            return;
        }
        $(this).closest('li').find('input').attr('checked', 'checked').trigger('change');
    });
	setFromCookie();

	$('.filter-collapsed').on('shown.bs.collapse', function(){
		showFilter();
	});

	$('.check-block').css('width', $('.check-block').css('width'));
});


function initFilter() {

	$('#filter-cat-selector').change(function (evt, params) {
		$('#filter .filter-cat').hide();
		$('#filter #filter-cat-'+$(this).val()).show();
	});

	$('#filter select').filter(":visible").filter(':not(.select2-hidden-accessible)').select2().bind('change', function(e){
		var top1 = $(this).parent().offset().top - ($(window).width() > 767 ? 218 : 20);
		$(".btn-filtr").css("top",top1+'px');
		if($(window).width() > 767)
		{
			$(".btn-filtr").css("left", $('#filter').outerWidth() + 'px');
		}
		else{
			$(".btn-filtr").css("left", $('#filter').outerWidth() -187+ 'px');
		}

		filterSubmit();
	});

	$('#filter-brands input[type=checkbox]').change(function(){
		var top1 = $(this).parent().offset().top - ($(window).width() > 767 ? 180 : 20);
		$(".btn-filtr").css("top",top1+'px');
		if($(window).width() > 767)
		{
			$(".btn-filtr").css("left", $('#filter').outerWidth() + 'px');
		}
		else{
			$(".btn-filtr").css("left", $('#filter').outerWidth() -187+ 'px');
		}

		filterSubmit();
	});
        $("[name=price_min],[name=price_max]").on('change', function() {
            checkInputMinMax(this);
        });
};
function checkInputMinMax(obj)  {
            var val = $(obj).val();
            if (val == "")  return;

            val = Number(val);
            var min = Number( $(obj).attr('min') );
            var max = Number( $(obj).attr('max') );
            console.log("min:"+min + " max:"+max+" val:"+val);

            if( min > 0 && val < min )  $(obj).val(min);
            else if( max > 0 && val > max )  $(obj).val(max);
}

function initFilter4() {
	$('#filter select').on('change', function(e){
		filterSubmit();
	});

};

function initFilter1() {
	$('.allwti select:not(.binded)').each(function () {
		var text = '';
		var name = $(this).attr('name');

		$(this).find('option').each(function (index) {
			text += '<div><input type="checkbox" name="'+name+'" id="'+this.value+'" value="'+this.value+'" '+(this.selected ? ' checked' : '')+'/><label for="'+this.value+'">'+this.innerHTML+'</label></div>'
			if (this.selected) {
					$(this).closest('.allwti').addClass('checked')
				$(this).closest('.allwti').find('.block').show();
			}
		});
		$(this).replaceWith(text);
	}).addClass('binded');
	$('.seceltfil:not(.binded)').toggle(function () {
      	$(this).closest('.allwti').find('.block').animate({height: 'show'}, 500);
    }, function() {
    	$(this).closest('.allwti').find('.block').animate({height: 'hide'}, 500);
	}).addClass('binded');
	$('.block input:not(.binded)').click(function () {
		if(this.checked){
			$(this).closest('.allwti').addClass('checked')
		}else{
			$(this).closest('.allwti').removeClass('checked')
		}
	});

	$('.filtrallblo input:not(.binded)').change(function(){
		filterSubmit();
	}).click(function(e){
    	var top = e.pageY - $(".filtrallblo").offset().top;
    	var top2 = top-13;
      	$(".btn-filtr").css("top",top2+'px');
	}).addClass('binded');

}

function getMultiAjax(cat){
 	var this_element = $(this);
    var ser = $(".idfiltr").serialize() + '&ajax_count=1';
    ser = ser.replace(/\w+=\&/g, '')
    $.get(location.pathname, ser, function(data) {
		$('.btn-filtr div span').text(data.total);
		if (data.lines) {
			$('select[name=line_id]').select2('destroy');
		}
		if ($('#filter-lines').length) {
			$('#filter-lines').replaceWith(data.lines);
		}
		else if (data.lines) {
			$('#filter-brands').after(data.lines);
		}
		initFilter();
		//$('select[name=line_id]').chosen();
    });
}


$(document).ready(function(){

	$('form[name="purchase"]').submit(function(event) {
		if(!this.cart_name.value){
			event.preventDefault();
			alert("Не заполнено имя");
                        return;
		}else if(!this.cart_phone.value) {
			event.preventDefault();
			alert("Не заполнен телефон");
                        return;
		}else if(!this.cart_delivery.value) {
			event.preventDefault();
			alert("Выберите способ доставки");
                        return;
		}else if(!this.approve.checked){
                        event.preventDefault();
                        alert("Пожалуйста ознакомтесь с Политикой конфиденциальности на нашем ресурсе и поставьте галочку для продолжения оформления заказа");
                        return;
                }
                $('form[name="purchase"] input[type="submit"]').prop('disabled', true);
	});

        function check_promo(promo)  {
            $.get("/shopcart/?check_promo="+promo, function(data){
                $("form[name=purchase] .cart_promo_text").removeClass("text-danger");
                $("form[name=purchase] .cart_promo_text").removeClass("text-info");
                if (data.result == "1")  {
                    $("form[name=purchase] .cart_promo_text").addClass("text-info");
                }
                else  {
                    data.text = "Промокод не найден!"
                    $("form[name=purchase] .cart_promo_text").addClass("text-danger");
                }

		$.cookie('promo_id', data.id || 0, {"path": '/'});
		$.cookie('promo_code', promo, {"path": '/'});

                $("form[name=purchase] .cart_promo_text").text(data.text);
            });
        }

	$('form[name=purchase] [name=check_promo_code]').click(function()  {
            var promo = $("form[name=purchase] [name=promo]").val();
            check_promo(promo);
        });

        var promo = $.cookie('promo_code');
        if (promo)  {
            check_promo(promo);
        }

});

function getPrice(str) {
    return parseInt((str + '').replace(/[^\,\.\d]/g, ''))
}

function feedbackPost(event) {
	event.preventDefault();

	var has_phone = this.elements.fb_phone;
	var has_mail = this.elements.fb_email;

	var has_name = this.elements.fb_name;

	var phone_test = 0;
	var mail_test = 0;

    var has_s3cr3t = this.elements.fb_s3cr3t;
    
    if (has_s3cr3t) {
        has_s3cr3t.value = 0;
    }
    
	if (has_name && !(has_name.value+'').match(/[a-zA-Zа-яА-Я]/)) {
		$(has_name).parent().addClass("has-error");
	}else{
		$(has_name).parent().removeClass("has-error");
	}

	if (has_phone && (has_phone.value+'').match(/[\d\- \(\)\+\.]{7,}/)) {
		phone_test = 1;
	}

	if (has_mail && (has_mail.value+'').match(/^\s*[\w\-\.]+\@[\w\-\.]+\s*$/)) {
		mail_test = 1;
	}

	if (!phone_test && !mail_test) {
		if (has_mail) {
			$(has_mail).parent().addClass("has-error");
		}
		if (has_phone) {
			$(has_phone).parent().addClass("has-error");
		}
		return;
	}
	if (this.elements.template && this.elements.template=='callback') {
		met.reachGoal('ZVONOK');
	}
	else if (this.elements.template && this.elements.template=='item') {
		met.reachGoal('FEEDBACK');
	}


	if (this.elements.template && this.elements.template.value=='callback' && typeof(yaCounter32942089) !== "undefined") {
        yaCounter32942089.reachGoal('Ring');
    }
	else if (this.elements.template && this.elements.template.value=='item' && typeof(yaCounter32942089) !== "undefined") {
		yaCounter32942089.reachGoal('Letter');
	}

	var $submit =$(this).find('.btn-primary,[type="submit"]');

    var f = $(this);
    var thisForm = this;
    challangeGreCaptcha(token => {
        $(f).find('[name="g-recaptcha-response"]').val(token);
        $.post('/5eed6ack/', $(f).serialize(), function (data) {
            if (data.error) {
                alert("reCapcha не пройден")
                return false;
            }

            if (thisForm.elements.template && thisForm.elements.template.value=='item1click') {
                Comagic.addOfflineRequest({
                    name: has_name.value,
                    email: '',
                    phone: has_phone.value,
                    message: 'Купить в 1 клик со страницы ' + thisForm.elements.fb_item.value
                });
            }
            else if (thisForm.elements.template && thisForm.elements.template.value=='callback') {
                Comagic.addOfflineRequest({
                    name: has_name.value,
                    email: '',
                    phone: has_phone.value,
                    message: 'Обратный звонок со страницы ' + thisForm.elements.fb_item.value
                });
            }
            var $msg = $(
                '<div class="msg">Спасибо, мы обязательно c Вами свяжемся. Окно закроется через 3с</div>;'
            )
            $submit.replaceWith($msg);

            setTimeout(function () {
                $('.close-reveal-modal').trigger('click');
                $('.modal.in').modal('hide');
            }, 3000)
        });
    });    
}

function DateThroughMounth() {
	var date = new Date();
	date.setTime(date.getTime() + (30*24*3600*1000));
	return date;
}
function MobileFilter(){
	if(window.innerWidth < 768){
		$('#mobile-filter').append($('#filter'));
                $('#filter').show();
		$('#filter .multi-collapse').removeClass('in');
	}
	else{
		$('#filter .show-filters--js').remove();
	}
}
function setFromCookie() {
	var organic = ['\\w*\\.?mail.ru', '\\w*\\.?rambler.ru', 'gogo.ru', 'nigma.ru', 'search.qip.ru', 'webalta.ru', 'sm.aport.ru', 'akavita.by', 'meta.ua','search.bigmir.net', 'search.tut.by', 'all.by', 'search.i.ua', 'index.online.ua', 'web20.a.ua', 'search.ukr.net', 'search.com.ua', 'search.ua', 'poisk.ru', 'go.km.ru', 'liveinternet.ru', 'ask', 'gde.ru', 'affiliates.quintura.com'];
	//var organic = ['\\w*\\.?yandex.ru', '\\w*\\.?mail.ru', '\\w*\\.?google\\.(com\\.ua|ru|com|by)', '\\w*\\.?rambler.ru', 'gogo.ru', 'nigma.ru', 'search.qip.ru', 'webalta.ru', 'sm.aport.ru', 'akavita.by', 'meta.ua','search.bigmir.net', 'search.tut.by', 'all.by', 'search.i.ua', 'index.online.ua', 'web20.a.ua', 'search.ukr.net', 'search.com.ua', 'search.ua', 'poisk.ru', 'go.km.ru', 'liveinternet.ru', 'ask', 'gde.ru', 'affiliates.quintura.com'];
	if ($ && $.cookie) {
		if (!$.cookie('from')) {

			var from = 'other';
			var source = '';
			var utm_source = '';
			var utm_campaign = '';


			if ((location.search+'').match(/utm_campaign=([^&]+)/)) {
				utm_campaign = RegExp.$1;
			}

			if ((location.search+'').match(/utm_source=([^&]+)/)) {
				utm_source = RegExp.$1;
				if(utm_source == 'YM')
				{
					from = 'market.yandex.ru';
				}
				else
				{
					from = 'direct.yandex.ru';
				}
			}
			else {
				var ref = document.referrer+'';
				for (var i=0; i<organic.length; i++) {
					var tmp_reg = "^(http|https)?(:\/\/)?("+organic[i]+')';
	//				console.log('Testing: '+ref+' '+tmp_reg);
					if (ref.match(new RegExp(tmp_reg))) {
						from = 'organic';
						source = RegExp.$3;
						break;
					}
				}

				var tmp_reg = "^(http|https)?(:\/\/)?(\\w*\\.?yandex.ru)";

				if (ref.match(new RegExp(tmp_reg))) {
					from = 'yandex.search';
					source = RegExp.$3;
				}

				var tmp_reg = "^(http|https)?(:\/\/)?(\\w*\\.?google\\.(com\\.ua|ru|com|by))";

				if (ref.match(new RegExp(tmp_reg))) {
					from = 'google.search';
					source = RegExp.$3;
				}
			}

			$.cookie('from', from, {
				path: '/',
				expires: DateThroughMounth()
			});

			$.cookie('source', source, {
				path: '/',
				expires: DateThroughMounth()
			});

			$.cookie('utm_source', utm_source, {
				path: '/',
				expires: DateThroughMounth()
			});

			$.cookie('utm_campaign', utm_campaign, {
				path: '/',
				expires: DateThroughMounth()
			});
		};

	}

	// запись в базу и вывод кода
	$.get("/setcode/?rnd="+Math.random(), function(data) {
		$('#code span').html(data);
		$('.code.pull-right').html(data);
	//	console.log('code span');
	});
}

function DateThroughMounth() {
	var date = new Date();
	date.setTime(date.getTime() + (30*24*3600*1000));
	return date;
}

function BrandsSelectorInit() {
	$('.brands-filter>nav').each(function () {
		$(this).affix({
		    offset: {
		      top: $('.brands-logos').position().top - $(this).height() - 10
		    }
		})
	});

	$('.brands-filter li a').click(function (event) {
		var id = $(this).attr('id');
		$('.brands-logos>div').hide();
		$('.brands-logos>div.'+id).show();
		$('.brands-filter li').removeClass('active');
		$(this).closest('li').addClass('active');
		if (id && $('#'+id).length) {
			location.hash = '#filter-'+id;
		}
		if (event) {
			event.preventDefault();
		}
		if (!$(this).closest('nav').hasClass('active')) {
			$('html,body').animate({scrollTop: $('.brands-logos').position().top-$(this).closest('nav').height()}, 500)
			$('.brands-filter nav').removeClass('active');
			$(this).closest('nav').addClass('active');
		}

	});
	if (!location.hash) {
		$('.brands-filter li a').first().trigger('click')
	}
	else {
		var id = location.hash.match(/filter-(.*)/) ? RegExp.$1 : '';
		if (id && $('#'+id).length) {
			$('#'+id).trigger('click');
		}
	}
}

function filterSubmit(event) {
	var $f = $('form.idfiltr');
	if ($f.attr('action')) {
		pathorigin  = $f.attr('action');
	}
	//event.preventDefault();
	if (event)
	{
		event.preventDefault();
	}

	var params = $f.serialize();
	params = params.replace(/\w+=\&/g, '')
	params = params.replace(/&\w+=$/g, '')
	var addurl = '';

	/////////

		if ($f.find('input[type="checkbox"][data-url!=""]:checked').length == 1) {
			//console.log($(this).attr('data-url') + ' ======');
				$opt = $f.find('input[type="checkbox"][data-url!=""]:checked');
				addurl += $opt.attr('data-url');
				addurl += '/';

				var Reg = new RegExp('(^|&)' + $opt.attr('name') + '=[^&]+');
				params = params.replace(Reg, '');

		//	console.log('params ' + params);
/*
			var $opt = $select.find('option[data-url]:selected');


			console.log('addurl');
			console.log($opt.attr('data-url'));


			if ($opt.attr('data-url')) {
				addurl += $opt.attr('data-url');
				addurl += '/';

				var Reg = new RegExp('(^|&)' + $opt.closest('select').attr('name') + '=[^&]+');
				params = params.replace(Reg, '');
			}
			else {
//				addurl = '';
			}

			*/
		}

	if ($f.hasClass('filter-parent')) {

	    $f.find('select').each(function () {
		var $select = $(this);
		if ($select.find('option[data-url!=""]:selected').length == 1) {
			var $opt = $select.find('option[data-url]:selected');

			if ($opt.attr('data-url')) {
				addurl += $opt.attr('data-url');
				addurl += '/';

				var Reg = new RegExp('(^|&)' + $opt.closest('select').attr('name') + '=[^&]+');
				params = params.replace(Reg, '');
			}
			else {
//				addurl = '';
			}
		}
	    });





		$('.navbar-filter .open').removeClass('open');
		if ((params || addurl) && event) {
			params = 'filter=1&' + params;
			location.href = pathorigin + addurl + (addurl ? '' : '?filter=1&')+ (params ? '#' : '') + params;
		};
		console.log('return filter-parent');
		return;
	}

	params = 'filter=1&' + params;
	// В-058
	history.pushState({"filter": params, "addurl": addurl}, document.title + ' - Фильтр по параметрам', pathorigin + addurl + (params ? '#' : '') + params);
//	$('.goods').addClass('loading');
//	$('body').addClass('loading2');
//	$('.filter-hide').hide();


//console.log( document.location.search  )
//console.log('2:' + '?' + params)

	if (document.location.search != '?' + params)  {
	    document.location.href = pathorigin+addurl+'?'+params;// В-058
	}

//	$.get(pathorigin+addurl, params+'&ajax=1',goodsUpdate);
// В-058
/*	if($(window).width() < 767){
// В-058
		$('html, body').animate({
			scrollTop: ($('.catalog-prod-in').offset().top - $('.header-xs').outerHeight())
		}, 500);
	}
*/
}

function goodsUpdate(data) {
	if ($('.numpage-one').length) {
		$('.numpage-one').replaceWith(data.pages);
	}

	if(data.pages && data.pages.match('numpage-one')) {
		if (!$('.numpage-one').length) {
			$('.catalog-prod-in').after(data.pages);
		}
		pages();
	}

	$('.count').html(data.count);
	$('.btn-filtr div span').text(data.count);
	$('.minprice').html(data.minprice);
	$('.maxprice').html(data.maxprice);
	$('input[name="price_min"]').attr('placeholder', data.minprice);
	$('input[name="price_max"]').attr('placeholder', data.maxprice);
	///////

	$('.catalog-prod-in').removeClass('loading').html(data.items);

	if (!parseInt(data.count)) {
		$('.catalog-prod-in').append('<div class="alert alert-warning">По данным параметрам не найдено ни одного товара</div>')
	}
	if (data.lines) {
		if (!$('#filter-lines').length) {
			$('#filter-brands').after(data.lines);
		}
		else {
			$('#filter-lines').replaceWith(data.lines);
		}
		$('#filter-lines select').filter(':not(.select2-hidden-accessible)').change(filterSubmit).select2({width: '100%'});
	};
	if ($('.catalog-prod-in').position().top < $(window).scrollTop()) {
		$('html,body').animate({scrollTop: $('#filter').position().top}, 300);
	}

	$('body').removeClass('loading2');
//	fixGoodsHeight();
}

function pages() {

	return true; // В-058

	$('.numpage-one a').click(function (event) {
		if ($('#filter').length) {
			event.preventDefault();
		}
		else {
			return;
		}

        var f = $('form.idfiltr').get(0);
        var page = $(this).attr('data-page');
        if (page == 1) {
            page = 0;
        }
        f.page.value = page;
        if (page) {
            f.page.classList.add('has-success');
        }
        else {
            f.page.classList.remove('has-success');
        }
        filterSubmit(event);
	})
}

function loadFilter(event) {
    var params = location.hash.replace(/^#/, '');
    var obj = {};
    params.split(/[\?\&]/).forEach(function (part) {
        var a = (part+'').split('=');
        a[0] = decodeURIComponent(a[0]);
        if (a[1]) {
            a[1] = decodeURIComponent(a[1].replace(/\+/, '%20'));
        }
        if (a[0] in obj) {
            if (typeof(obj[a[0]]) !== 'object') {
                var tmp = obj[a[0]];
                obj[a[0]] = new Array(tmp);
            }
            obj[a[0]].push(a[1]);
        }
        else {
            obj[a[0]] = a[1];
        }
    });

    var $filter = $('form.idfiltr');
    for (var key in obj) {
        var input = $filter.find('[name="'+key+'"]').get(0);
        if (input) {
            if (input.tagName == 'SELECT') {
                if (typeof(obj[key]) != 'object')
                    obj[key] = [obj[key]];
                for (var i=0;i<obj[key].length;i++) {
                    $(input).find('option[value="'+obj[key][i]+'"]').prop('selected', true);

                }
              // $(input).trigger('select2:updated');
           }
            else {
                if (input.type == 'checkbox') {
					input.checked = obj[key] ? true : false;
                }
                else {
                    $(input).val(obj[key]);
                    if (input.type == 'text') {
                        input.classList.add('has-success');
                    }
                }
            }
        };
    }

    for (var key in obj) {
        $filter.find('[name="'+key+'"]').each(function(){
			if ($(this).prop("tagName") == 'INPUT' && $(this).prop('type') == 'checkbox') {
					if (typeof(obj[key]) != 'object')
						obj[key] = [obj[key]];
					for (var i=0;i<obj[key].length;i++) {
						//$(input).find('option[value="'+obj[key][i]+'"]').prop('selected', true);
					//	input.checked = obj[key] ? true : false;
						if($(this).val() == obj[key][i])
						{
							$(this).attr('checked', 'checked');
						}
					}
			}
		});
	}

    //$filter.find('select').trigger("chosen:updated");
    var event = 'Event' in window ?
        new Event('submit') :
        null;

    filterSubmit(event);
}

function cartModify() {
}

function lowerpricePost(event) {
	event.preventDefault();

	var has_phone = this.elements.fb_phone;
	var has_mail = this.elements.fb_email;

	var has_name = this.elements.fb_name;

	var phone_test = 0;
	var mail_test = 0;

	if (has_name && !(has_name.value+'').match(/[a-zA-Zа-яА-Я]/)) {
		$(has_name).parent().addClass("has-error");
	}else{
		$(has_name).parent().removeClass("has-error");
	}

	if (has_phone && (has_phone.value+'').match(/[\d\- \(\)\+\.]{7,}/)) {
		phone_test = 1;
	}

	if (has_mail && (has_mail.value+'').match(/^\s*[\w\-\.]+\@[\w\-\.]+\s*$/)) {
		mail_test = 1;
	}

	if (!phone_test && !mail_test) {
		if (has_mail) {
			$(has_mail).parent().addClass("has-error");
		}
		if (has_phone) {
			$(has_phone).parent().addClass("has-error");
		}
		return;
	}
/*
	$.post('/5eed6ack/', $(this).serialize(), function () {
		var $msg = $('<div class="msg">Спасибо, мы обязательно c Вами свяжемся. Окно закроется через 3с</div>;')
		$submit.replaceWith($msg);

		setTimeout(function () {
			$('.close-reveal-modal').trigger('click');
            $('.modal.in').modal('hide');
		}, 3000)
	});
	*/
	//
	//var $submit = $(f).find('.btn-primary,[type="submit"]');
	var $submit =$(this).find('.btn-primary,[type="submit"]');

	var fd = new FormData($("form.lowerprice-form")[0]);

	fd.append('fb_file', $('input[name=fb_file]')[0].files[0]);

    $.ajax( {
		url: '/5eed6ack/',
		type: 'POST',
		data:  fd,
		processData: false,
		contentType: false,
		success: function(data){
			var $msg = $('<div class="msg">Спасибо, мы обязательно c Вами свяжемся. Окно закроется через 3с</div>;')
			$submit.replaceWith($msg);

			setTimeout(function () {
				$('.fancybox-close').trigger('click');
				$('.close-reveal-modal').trigger('click');
				$('.modal.in').modal('hide');
			}, 3000)
		}
	} );
	return false;

}

function runEcommerce() {
	var items = [];
	var $p = $('#print_order');

	if (!$p.html()) return;
	if(!window.gtag) return;

	$p.find('.item').each(function () {
		var $this = $(this);
		var item = {
			'id': parseInt($p.find('.order_id').first().text()),
			'name': $this.find('.name').first().text(),
			'sku': $this.find('.item_id').first().text(),
			'price': parseFloat(($this.find('.sum').first().text()+'').replace(/[^\d\.]/g, "")),
			'quantity': parseFloat($this.find('.count').first().text()),
			"currency": "RUB"
		};
		console.log(item);
		items.push(item);
	});

	gtag("event",  "purchase",  {
		"transaction_id": parseInt($p.find('.order_id').first().text()),
		"currency": "RUB",
		"shipping": parseInt($p.find('.delivery').first().text()) || 0,
		"value": parseInt(($p.find('.total').first().text()+'').replace(/[^\d\.]/g, "")),
		"items": items
	});

	$(window).on("load", function(){
		Comagic.addOfflineRequest({
			name: $('#cart_name').text(),
			email: $('#cart_email').text(),
			phone: $('#cart_phone').text(),
			message: 'Заказ № ' + $('.order_id').text(),
            is_sale: true,
            sale_cost: $(".total").text(),
		});
	});
}

function showSuggestion(suggestion) {
	console.log(suggestion);
	var data = suggestion.data;
	if (!data) return;

	$('[name=cart_comments]').val(
	(data.value ? 'Наименование: ' + data.value : '') +
	(data.address.value ? '\nАдрес: ' + data.address.value : '') +
	(data.inn ? '\nИНН: ' + data.inn : '') +
	(data.kpp ? '\nКПП: ' + data.kpp : '') +
	(data.ogrn ? '\nОГРН: ' + data.ogrn : '') +
	(data.okved ? '\nКод ОКВЭД: ' + data.okved : '') +
	(data.opf.code ? '\nКод ОКОПФ: ' + data.opf.code : '')
	);
}

function formatPrices(text) {
	if (text.match(/(\d\d\d\d+)/)) {
		var count = RegExp.$1;
		var count_text = '';
		while (count >= 1) {
			count_text = (count % 1000)+' '+count_text;
			if (count >= 1000) {
                if (count%1000 < 100) {
                    count_text = '0'+count_text;
                }
                if (count%1000 < 10) {
                    count_text = '0'+count_text;
                }
            }
			count = parseInt(count/1000);
		}
        count_text = count_text.replace(/( )+$/, '');
		return text.replace(/\d\d\d\d+/, count_text);
	}
	return text;
}

function initGoodsSwiper(target) {

    

    var countTrigger = $(target).find('.item').length;
    // $(target).find('.swiper-button-next, .swiper-button-prev').toggleClass('d-none', countTrigger);

    const goodSwiper = new Swiper(target, {
        slideClass: 'item',
        slidesPerView: 1,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        navigation: {
            enabled: true,
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        noSwiping: true,
        noSwipingSelector: 'button',
        preventClicks: true,
        breakpoints: {
            1600: {
                slidesPerView: 4,
                navigation: {
                    enabled: countTrigger > 4 ? true : false
                  },
                  loop: countTrigger > 4 ?  true : false,
              },
            1200: {
                slidesPerView: 3,
                navigation: {
                    enabled: countTrigger > 3 ? true : false
                  },
                  loop: countTrigger > 3 ?  true : false,
              },
              992: {
                loop: countTrigger > 3 ? true : false,
                navigation: {
                    enabled: countTrigger > 3 ? true : false
                  },
                slidesPerView: 3,
            },
            768: {
                loop: countTrigger > 2 ? true : false,
                navigation: {
                    enabled: countTrigger > 2 ? true : false
                  },
                slidesPerView: 2,
            },
        }
    })
}

function challangeGreCaptcha(callback) {
    if (!window.grecaptcha) {
        initGreCapcha(callback);
        return;
    };

    window.grecaptcha.execute(
        window.GOOGLE_CAPTCHA_SITE_KEY, {action: 'submit'}
    ).then(callback);
}

function initGreCapcha(callback) {
    if (!window.GOOGLE_CAPTCHA_SITE_KEY) {
        console.error('window.GOOGLE_CAPTCHA_SITE_KEY not set')
    }
    const url = 'https://www.google.com/recaptcha/api.js';
    $.getScript(`${url}?render=${window.GOOGLE_CAPTCHA_SITE_KEY}`, () => {
        window.grecaptcha.ready(() => challangeGreCaptcha(callback))
    })
}